module.exports = __webpack_public_path__ + "static/media/4-R-Smart Expert.3f1a1750.jpg";